import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource-variable/inter/index.css";
import "@fontsource-variable/jetbrains-mono/index.css";
import "@/styles/tokens.css";
import "@/styles/base.css";
import "@/ui/ui.css";
import App from "./App";
import { initAnalytics } from "@/analytics/service";
import { initPerfObservers } from "@/analytics/perf";
import { restoreThemePack } from "@/market/theme";

initAnalytics();
initPerfObservers(() => location.pathname.split("/")[1] || "landing");
restoreThemePack();

// PWA: register the shell service worker in production only, so dev HMR is
// never intercepted. Failures are non-fatal; the app works without it.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
